




import {Component, Prop, Vue} from 'vue-property-decorator'
import DataGrid from '@/components/DataGrid.vue'
import {executeQuery} from "@/data/repos/query"
import {formatDate, reformatDate} from "@/data/sources/dates"

@Component({
  components: {
    DataGrid,
  },
})
export default class HDInhouseStatutoryComplianceCompletedForMonthToDateGrid extends Vue {
  @Prop() public args!: {
    year: number,
    month: number,
    status: number,
  }
  public fields = [
    {name: 'PPM_Occ_Id', title: 'PPM occ id', dataType: 'Number', sort: 1},
    {name: 'PPM_Start_DateTime', title: 'Start date time', dataType: 'Date', sort: 1},
    {name: 'PPM_Due_Date', title: 'Due date time', dataType: 'Date', sort: 1},
    {name: 'PPM_Short_Desc', title: 'Short description', dataType: 'Text', sort: 1},
    {name: 'Site_Desc', title: 'Site', dataType: 'Text', sort: 1},
    {name: 'Building_Desc', title: 'Building', dataType: 'Text', sort: 1},
    {name: 'PPM_Status', title: 'Status', dataType: 'Text', sort: 1},
    {name: 'PPM_Comp_DateTime', title: 'Completed', dataType: 'Date', sort: 1},
  ]

  public getData(offset: number = 0, limit: number = 250) {
    const args = this.args
    return executeQuery("FMS_DB", "inhouseStatutoryComplianceCompletedForMonthToDateGrid",
      {year: args.year, month: args.month, status: args.status},
      filter,
      offset, limit,
    )
  }
}

function filter(data: any[]): any[] {
  return data.map(item => {
    return {
      ...item,
      PPM_Start_DateTime: reformatDate(item.PPM_Start_DateTime),
      PPM_Due_Date: reformatDate(item.PPM_Due_Date),
      PPM_Comp_DateTime: reformatDate(item.PPM_Comp_DateTime),
    }
  })
}
